import React from 'react';
import { Redirect, useParams } from 'react-router-dom';

export function TaskViewerRedirect() {
  const { courseId, taskId, workflowId } = useParams<{
    courseId: string;
    taskId?: string;
    workflowId?: string;
  }>();

  if (workflowId) {
    const qs = taskId ? `?stepId=${taskId}&isWorkflow=true` : '?isWorkflow=true';
    return <Redirect to={`/training-steps/${workflowId}${qs}`} />;
  }

  const qs = taskId ? `?stepId=${taskId}` : '';
  return <Redirect to={`/training-steps/${courseId}${qs}`} />;
}
